module.exports = __webpack_public_path__ + "static/media/S30_B.8cc8f2b8.png";